<!-- job 运行日志主页 -->
<template>
  <div>
    <section class="search-form">
      <el-form
        :model="originData"
        :rules="rules"
        ref="searchForm"
        inline
      >
        <el-form-item
          prop="jobId"
          label="任务ID"
        >
          <el-input v-model="originData.jobId"></el-input>
        </el-form-item>
        <el-form-item
          label="任务名称"
          prop="serviceName"
        >
          <el-input
            @keyup.native="filterInput(originData, 'serviceName')"
            v-model="originData.serviceName"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="startTime"
          label="执行日期"
          style="margin-right: 13px;"
        >
          <el-date-picker
            v-model="originData.startTime"
            :picker-options="startPickerOptions"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          prop="startTime"
          label="至"
        >
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="originData.endTime"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="运行结果">
          <el-select
            v-model="originData.resultStatus"
            clearable
          >
            <el-option
              v-for="item in resultStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </section>
    <div class='flex-between'>
      <div>
        <el-button
          size="small"
          @click="handleQueryClick"
          type="primary"
        >查询</el-button>
        <el-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</el-button>
      </div>
    </div>

    <el-table
      border
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
    >
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        v-for='(item,index) in tableList'
        :label="item.label"
        :min-width="item.width"
        :prop="item.prop"
        :key='index'
        :formatter="formatter"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="130"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="handleViewClick(scope.row)"
              v-if="functionList.includes('322592238881968128')"
            >查看出错信息</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <yh-dialog
      :visible.sync="visibleDetail"
      title="出错信息"
    >
      <el-form>
        <el-form-item label="日志ID">
          <el-input
            :value="detailData.id"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="错误信息">
          <el-input
            autosize
            disabled
            type="textarea"
            :value="detailData.mistakeInform"
          ></el-input>
        </el-form-item>
      </el-form>
    </yh-dialog>
  </div>
</template>
<script>
import { getPagingData, getFunctionList } from '@/mixins';

export default {
  name: 'JobRunLog',
  mixins: [getPagingData, getFunctionList],
  data() {
    const { query } = this.$route;
    const validateName = (rule, value, cb) => {
      if (value.length > 50) {
        cb(this.$MSG.M0047);
      } else {
        cb();
      }
    };
    return {
      functionList: [],
      rules: {
        serviceName: [{
          validator: validateName,
        }],
        jobId: [{
          validator: (rule, value, cb) => {
            if (/^\d+$/g.test(value) || !value) {
              cb();
            } else {
              cb(this.$MSG.M0213);
            }
          },
        }],
      },
      visibleDetail: false,
      emptyText: this.$LS.empty,
      detailData: {},
      originData: {
        resultStatus: '',
        jobId: query.jobId || '',
        startTime: '',
        endTime: '',
        serviceName: '',
      },
      resultStatusList: [{
        label: '成功',
        value: 0,
      }, {
        label: '失败',
        value: 1,
      }],
      resultStatusMap: {
        0: '成功',
        1: '失败',
      },
      searchParam: {
        resultStatus: '',
        jobId: '',
        startTime: '',
        endTime: '',
        serviceName: '',
      },
      tableData: [],
      carLevelFlagBox: [
        {
          label: '成功',
          value: '1',
        },
        {
          label: '失败',
          value: '0',
        },
      ],
      tableList: [
        {
          prop: 'id',
          label: '日志ID',
          width: '200',
        },
        {
          prop: 'jobId',
          label: '定时任务ID',
          width: '200',
        },
        {
          prop: 'serviceName',
          label: '任务名称',
          width: '200',
        },
        {
          prop: 'resultStatus',
          label: '运行结果',
          width: '80',
        },
        {
          prop: 'endTime',
          label: '执行时间',
          width: '180',
        },
        {
          prop: 'executeId',
          label: '执行人',
          width: '200',
        },
      ],
      currentPage: 1,
      pageSize: 10,
      sumCount: 0, // 总记录数
      radio: '',
      dictValue: '',
    };
  },
  computed: {
    startPickerOptions() {
      return {
        disabledDate: (time) => {
          const notAfter = this.originData.endTime;
          if (notAfter) {
            return time.getTime() > notAfter.getTime();
          }
          return false;
        },
      };
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const notBefore = this.originData.startTime;
          if (notBefore) {
            return time.getTime() < notBefore.getTime();
          }
          return false;
        },
      };
    },
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.getTableData();
      },
    },
  },
  activated() {
    const { query } = this.$route;
    if (query && query.id) {
      this.originData.jobId = query.id;
      this.searchParam.jobId = query.id;
    }
    this.getTableData();
  },
  methods: {
    filterInput(obj, key) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = obj[key].replace(/[^\w\u4E00-\u9FA5]/g, '');
    },
    formatter(row, col, value) {
      if (col.property === 'resultStatus') {
        return this.resultStatusMap[value] || '-';
      }
      return value || '-';
    },
    handleViewClick(row) {
      this.detailData = row;
      this.visibleDetail = true;
    },
    // 重置按钮点击事件
    handleResetClick() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    transformList(list) {
      function isSuccessful(item) {
        return item.resultStatus === 1;
      }
      return list.map(item => ({
        ...item,
        resultStatus: isSuccessful(item) ? '成功' : '失败',
      }));
    },
    handleQueryClick() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          const startTime = this.originData.startTime ? this.formatDate(this.originData.startTime) : '';
          const endTime = this.originData.endTime ? this.formatDate(this.originData.endTime) : '';
          this.searchParam = { ...this.originData, startTime, endTime };
          if (this.currentPage === 1) {
            this.getTableData();
          } else {
            this.currentPage = 1;
          }
        }
      });
    },
    getTableData() {
      this.getPagingData(this.$API.jobRunLogQuery);
    },
  },
};
</script>
